module.exports = __webpack_public_path__ + "static/media/venue-3.5ae505e6.jpg";